import { render, staticRenderFns } from "./NotificationsWrapper.vue?vue&type=template&id=0bd4b5f8&scoped=true"
import script from "./NotificationsWrapper.vue?vue&type=script&lang=js"
export * from "./NotificationsWrapper.vue?vue&type=script&lang=js"
import style0 from "./NotificationsWrapper.vue?vue&type=style&index=0&id=0bd4b5f8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd4b5f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bd4b5f8')) {
      api.createRecord('0bd4b5f8', component.options)
    } else {
      api.reload('0bd4b5f8', component.options)
    }
    module.hot.accept("./NotificationsWrapper.vue?vue&type=template&id=0bd4b5f8&scoped=true", function () {
      api.rerender('0bd4b5f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notifications/RoomNotifications/NotificationsWrapper.vue"
export default component.exports